import { StyledCol } from '@/shared/styles';
import { isMobileOnly } from 'react-device-detect';
import styled from 'styled-components';

export const StyledA11yCheckerContainer = styled(StyledCol)`
  gap: 48px;
  padding: ${(props) => props.$padding || (isMobileOnly ? '32px 20px' : '60px')};
`;
